export default __webpack_public_path__ + "static/media/Densely Grassed.64a46951.png";